module.exports = __webpack_public_path__ + "static/media/bat5.14ca1505.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/bat5.png
// module id = 473
// module chunks = 0